import { render, staticRenderFns } from "./FindDocument.vue?vue&type=template&id=a55f3f86&"
import script from "./FindDocument.vue?vue&type=script&lang=ts&"
export * from "./FindDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports